import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './modules/user'
import getters from './getters'
import points from './modules/points'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    points,
  },
  getters,
  plugins: [
    createPersistedState({
      paths: ['user','points']
    })
  ]
})

export default store
